<template>
  <div class="foot of_h">
    <div class="webinfo">
      <!-- <div>Copyright © 2000 - 2020 　All Rights Reserve 版权所有 经济日报社 京ICP备15055676号-1 </div> -->
       <!-- 修改备案号 by tq time 20211027 -->
      <div>
        <p>Copyright © 2000 - {{$fun.getDate()}} 　All Rights Reserve 版权所有 经济日报社</p>
        <!-- <p>联系电话：18910257336（微信同号）010-58392313</p> -->
         <p>联系电话：15300311126 010-58392313</p>
        <div style="width:300px;margin:0 auto; padding:20px 0;">
		 		  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009786" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/assets/image/common/keep_record.png" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010202009786号</p>
          </a>
		 	  </div>
      </div>
    </div>
    <!-- <div class="QRcode">
      <img src="@/assets/image/community/ewm.png">
      <div class="name">中经视觉客服微信</div>
    </div> -->

  </div>
</template>

<script>
import { record_save } from '@/utils/api/activity.js'
export default {
  methods: {
    // 浏览量
    look_data () {
      record_save().then((res) => {
        let data = res.data;
        // console.log(data);
      })
    },
  },
  created () {
    this.look_data();//浏览量

  },
}

</script>

<style lang="scss" scoped="scoped">
div.foot {
  // height: 180px;
  padding: 60px 0px 50px;
  background-size: 100%;
  background-image: url(../../../assets/image/community/footer-bg.jpg);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  div.webinfo {
    width: 800px;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    // margin: 50px auto 0 auto;
    // div {
    //   height: 30px;
    //   line-height: 30px;
    //   color: #fff;
    //   font-size: 14px;
    //   text-align: center;
    // }
  }
  div.QRcode {
    width: 100px;
    height: 130px;
    position: absolute;
    top: 30px;
    left: 50%;
    margin-left: 500px;
    img {
      display: block;
      width: 100px;
      height: 100px;
    }
    div.name {
      height: 30px;
      line-height: 30px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/common/communityFoot.vue